import {
  AbholzeitType,
  Terminart,
  RemoteResult,
  Oeffnungszeiten,
  Oeffnungszeiten_Oeffnung as Oeffnung,
  OeffnungRequest,
  BPAbholungTerminWaehlenRequest,
} from "mangdto"

import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import moment from "moment"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"

export default class TerminAbholungLogic extends BaseLogic {
  selectedAbholType: AbholzeitType = AbholzeitType.Baldest
  private _selectedDate?: string = null
  selectedTime?: string = null
  selectedOeffnung: Oeffnung = null
  geoeffneteTage: Oeffnung[] = []
  minDate?: string = null
  maxDate?: string = null
  uhrzeiten = []
  insertWorking: boolean = false
  insertError: boolean = false
  abholzeitType: string = null
  uhrzeit: string = null
  changeMode: boolean = false

  get abholtypes() {
    if (!this.filiale.oeffnungHeute.geoeffnetKueche) {
      return [{ label: "Termin wählen", value: AbholzeitType.Uhrzeit }]
    }
    return [
      { label: "Schnellstmöglich", value: AbholzeitType.Baldest },
      { label: "Termin wählen", value: AbholzeitType.Uhrzeit },
    ]
  }

  get selectedDate(): string {
    return this._selectedDate
  }

  get weiterDisabled(): boolean {
    if (this.selectedAbholType == AbholzeitType.Baldest) return false
    if (this.selectedDate == null || this.selectedTime == null) return true
    return false
  }

  set selectedDate(value: string) {
    this._selectedDate = value

    let oeffnung = null

    this.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum == value) {
        oeffnung = toCompare
        return
      }
    })
    this.selectedOeffnung = oeffnung

    var uz = []

    this.selectedOeffnung.oeffnungszeiten.forEach((oz) => {
      var vonTemp = moment(oz.zeitVon, "HH:mm:ss").clone()
      var bis = moment(oz.zeitBis, "HH:mm:ss")

      while (vonTemp.isBefore(bis)) {
        uz.push(vonTemp.clone())
        vonTemp.add(15, "minutes")
      }
    })
    this.uhrzeiten = uz.map((el) => {
      return el.format("HH:mm")
    })
  }

  direktWeiter() {
    if (this.filiale.abholungSettings.verzehrVorOrt) {
      router.push({ name: RouteNames.NEU.VERZEHRART })
    } else {
      router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
    }
  }

  terminAuswaehlen() {
    this.insertWorking = true
    this.insertError = false

    var request = new BPAbholungTerminWaehlenRequest()
    request.id = vuexStore.state.user.identifier
    request.type = this.selectedAbholType

    if (this.selectedAbholType == AbholzeitType.Uhrzeit) {
      request.zeitpunkt = this._selectedDate + "T" + this.selectedTime
    }

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingAbholungTermin,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.abholung.abholzeitType =
            this.selectedAbholType
          if (this.selectedAbholType) {
            this.mainLogic.bestellungPending.abholung.gewaehlteUhrzeit =
              response.data.payload
          }

          if (this.filiale.abholungSettings.verzehrVorOrt) {
            router.push({ name: RouteNames.NEU.VERZEHRART })
          } else {
            router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
          }
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  terminBearbeiten() {
    this.changeMode = true
  }

  get editMode(): boolean {
    var type = this.mainLogic.bestellungPending.abholung.abholzeitType
    if (type != null) return false
    return true
  }

  init() {
    var type = this.mainLogic.bestellungPending.abholung.abholzeitType
    var zeit = this.mainLogic.bestellungPending.abholung.gewaehlteUhrzeit
    this.abholzeitType = type
    this.uhrzeit = zeit

    if (!this.abholzeitType) {
      this.changeMode = true
    } else {
      this.changeMode = false
    }

    this.mainLogic.bestellungPendingListeners.push(() => {
      var type = this.mainLogic.bestellungPending.abholung.abholzeitType
      var zeit = this.mainLogic.bestellungPending.abholung.gewaehlteUhrzeit
      this.abholzeitType = type
      this.uhrzeit = zeit

      if (!this.abholzeitType) {
        this.changeMode = true
      } else {
        this.changeMode = false
      }
    })

    if (!this.filiale.zurZeitGeoeffnetKueche) {
      this.selectedAbholType = AbholzeitType.Uhrzeit
    }

    var filialeId = this.filiale.filialeId
    var request = new OeffnungRequest()
    request.filialeId = filialeId
    request.terminart = Terminart.Abholung

    Poster.postUser<RemoteResult<Oeffnungszeiten>>(
      RestPaths.oeffnungszeitOeffnungszeitenKueche,
      request,
    ).then((response) => {
      this.minDate = response.data.payload.minDate
      this.maxDate = response.data.payload.maxDate
      this.geoeffneteTage = response.data.payload.daten
    })
  }

  datumWaehlen() {}
}
